export default __webpack_public_path__ + "static/media/etihadLoaderLogo.8b4d89e1.svg";